import Box from '@mui/material/Box';
import {vacancies, Vacancy} from './constants';
import { Text } from './Careers.style';
import {
  VacanciesListContainer,
  RequirementsList,
  VacancyApplyLink,
  VacancyListItem,
} from './VacanciesList.style';

export const VacanciesList = () => {
  return (
    <Box mt={[4]}>
      <VacanciesListContainer>
        {vacancies.map((item: Vacancy) => (
          <VacancyListItem key={item.id} id={item.id}>
            <h2>{item.title}</h2>
            <Text>{item.description}</Text>
            <h3>Responsibilities:</h3>
            <RequirementsList>
              {item.responsabilities.map((text, index) => (
                <li key={index}>{text}</li>
              ))}
            </RequirementsList>
            <h3>Requirements:</h3>
            <RequirementsList>
              {item.requirements.map((text, index) => (
                <li key={index}>{text}</li>
              ))}
            </RequirementsList>
            <h3>Valuable assets in your role:</h3>
            <RequirementsList>
              {item.valuableAssets.map((text, index) => (
                <li key={index}>{text}</li>
              ))}
            </RequirementsList>
            <Box mt={[3]}>
              To apply send your CV and motivation to <VacancyApplyLink href="mailto: jobs@ailivesim.com">Jobs@ailivesim.com</VacancyApplyLink> with the subject<br/> &apos;{item.title}&apos;<br/>Positions fill as soon as a relevant candidate is found.
            </Box>
          </VacancyListItem>
        ))}
      </VacanciesListContainer>
    </Box>
  );
};
